<template>
  <div class="history">
    <div class="el-checkbox-group history-layer">
      <el-tag size="mini"
              style="float:left;margin-left:5px;"
              v-show="curMachineAlias">{{curMachineAlias}} {{tarId}}</el-tag>
      <Version :value="version"></Version>
      <template v-if="version==='1'">
        <el-checkbox :value="true"
                     disabled>原图</el-checkbox>
        <el-checkbox v-model="showDetect">检测结果</el-checkbox>
        <el-checkbox v-model="showLabel">标注</el-checkbox>
        <el-checkbox v-model="showBlind">屏蔽区</el-checkbox>
      </template>
      <el-checkbox-group v-model="visiableLayers"
                         style="display:inline-block;margin-right:30px;"
                         v-if="version==='2'">
        <el-checkbox label="BASE_LAYER"
                     disabled>原图</el-checkbox>
        <el-checkbox label="DETECT_RESULT">检测结果</el-checkbox>
        <el-checkbox label="LABEL">标注</el-checkbox>
        <el-checkbox label="SHIELD_MANUALLY">结构件屏蔽</el-checkbox>
        <el-checkbox label="SHIELD_LINE">屏蔽</el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-model="showMagnifier">放大镜
        <span @click.prevent="diameter>2&&diameter--"
              style="padding:0 5px">−</span>
        <span @click.prevent>{{diameter}}</span>
        <span @click.prevent="diameter++"
              style="padding:0 5px">+</span>
      </el-checkbox>
      <el-select v-model="bitRate"
                 placeholder="请选择视频码率"
                 title="请选择视频码率"
                 size="mini"
                 class="bitrate-select">
        <el-option v-for="item in videoBitRate"
                   :key="item.bitRate"
                   :label="item.label"
                   :value="item.bitRate">
        </el-option>
      </el-select>
    </div>
    <div class="history-labeler"
         @mousewheel.prevent="onMouseWheel">
      <h1 v-if="!tarId">请在左侧选择数据包</h1>
      <Labeler v-else-if="version==='1'"
               :video-url="videoUrl"
               :yaml-url="yamlUrl"
               :label-list="filteredLabels"
               :show-draw="false"
               :show-magnifier="showMagnifier"
               :blind="shieldInfo"
               v-model="frameIdx"
               @decoded="onDecoded" />
      <template v-else-if="version==='2'">
        <WebGLSnapshot :visiable-layers="visiableLayers"
                       :base-layer="curBaseLayer"
                       :layer-data="curLayerData"
                       :tools="tools"
                       mode="VIEW"></WebGLSnapshot>
        <PlayControl></PlayControl>
      </template>
      <div class="history-camera">
        摄像头：
        <el-select size="small"
                   v-model="cameraIdx"
                   placeholder="Select">
          <el-option v-for="(cameraId,idx) in cameraList"
                     :key="cameraId"
                     :label="cameraId"
                     :value="idx">
          </el-option>
        </el-select>&nbsp;&nbsp;
        <el-button size="mini"
                   :disabled="isLoading||cameraIdx<1"
                   @click="cameraIdx--">上一个摄像头</el-button>
        <el-button size="mini"
                   :disabled="isLoading||cameraIdx>=cameraList.length-1"
                   @click="cameraIdx++">下一个摄像头</el-button>
      </div>
    </div>
    <div class="box"
         style="display:flex;justify-content:space-between;align-items:center;">
      <div>审核历史:
        <el-select v-model="selectedHistoryIdx"
                   size="small"
                   placeholder="请选择历史版本"
                   style="width: 650px;">
          <el-option v-for="(history,idx) in historys"
                     :key="idx"
                     :label="'【审核人】'+history.reviewerName+' 【审核时间】'+history.reviewTime+' 【状态】'+history.reviewStatusLabel+' 【标注人】'+history.labelerName"
                     :value="idx">
          </el-option>
        </el-select>
        <div v-if="historys.length"></div>
        <span v-else> 此数据包暂无审核记录</span>
      </div>
    </div>
    <div class="box history-info"
         v-if="historys.length>0">
      <el-table :data="labelTable"
                size="small"
                style="align-self: flex-start;">
        <el-table-column prop="bestLabeling"
                         label="最佳标注"></el-table-column>
        <el-table-column prop="detectionMachineId"
                         label="检测机 ID"></el-table-column>
        <el-table-column prop="factoryName"
                         label="工厂名称"></el-table-column>
        <el-table-column prop="labelComment"
                         label="标注备注"></el-table-column>
        <el-table-column prop="labelTime"
                         label="标注时间"></el-table-column>
        <el-table-column prop="machineAlias"
                         label="机器别名"></el-table-column>
        <el-table-column prop="reviewComment"
                         label="审核备注"></el-table-column>
        <el-table-column prop="reviewStatus"
                         label="审核状态"></el-table-column>
        <el-table-column prop="reviewTime"
                         label="审核时间"></el-table-column>
        <el-table-column prop="reviewerName"
                         label="审核人"></el-table-column>
      </el-table>
      <div style="display:flex;margin:20px 0;">
        <ul class="history-list"
            style="flex:1;min-width: 300px;height: auto;overflow:auto;align-self: stretch;margin:0;max-width: 400px;">
          <li v-for="(label,idx) in labels"
              :key="idx"
              :class="{active:idx===selectedLabel}"
              @click="selectedLabel=idx">
            <span style="display:flex;">
              {{labelTypes[label.type].title}}
              [{{label.frameRange.join(',')}}]
            </span>
            <span>
              <el-button size="mini"
                         @click="frameIdx=label.frameRange[0]">定位</el-button>
            </span>
          </li>
        </ul>
        <ClothAssessment v-model="labelInfo.clothAssessment"
                         :config="clothAssessmentConfig"
                         :worning-keys="diffClothAssessment"
                         readonly></ClothAssessment>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import c from '@/config'
import Version from '@/components/Version'
import Labeler from '@/components/Labeler'
import PlayControl from '@/components/PlayControl'
import ClothAssessment from '@/components/ClothAssessment'
import WebGLSnapshot from '@/components/WebGLSnapshot'

export default {
  data() {
    return {
      debug: c.debug,
      version: c.version,
      frameRangeLoc: this.frameRange || [],
      labelTypes: Object.freeze(c.labelTypes),
      videoBitRate: Object.freeze(c.videoBitRate),
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.privileges.LabelingBasic) {
      this.tarId = to.query.tarid || ''
    }
    next()
  },
  mounted() {
    if (this.privileges.LabelingBasic) {
      const queryTarId = this.$route.query.tarid || ''
      if (queryTarId && this.tarId === queryTarId) {
        this.fetchCameraList(this.tarId)
      } else {
        this.tarId = queryTarId
      }
    }
  },
  computed: {
    ...mapFields([
      'showMagnifier',
      'visiableLayers',

      'bitRate',
      'tarId',
      'frameIdx',
      'frameRange',
      'cameraIdx',
      'showDetect',
      'showLabel',
      'showBlind',

      'modified',

      'diameter',
      'isPlaying',

      // 'history.historys',
      'history.selectedLabel',
      'history.selectedHistoryIdx',
      'history.reviewComment',
      'history.bestLabeling',
    ]),
    ...mapState([
      'privileges',
      'cameraList',
      'videoUrl',
      'yamlUrl',
      'alias',
      'clothAssessmentConfig',
      'shieldInfo',
    ]),
    ...mapGetters(['cameraId', 'isLoading']),
    ...mapGetters('history', [
      'historys',
      'labels',
      'diffClothAssessment',
      'labelInfo',
      'labelTable',

      'curLayerData',
      'curBaseLayer',
      'tools',
    ]),
    filteredLabels() {
      return this.labels.filter(
        label =>
          label.frameRange[0] <= this.frameIdx &&
          label.frameRange[1] >= this.frameIdx,
      )
    },
    curMachineAlias() {
      if (this.tarId === '') return ''
      const machineId = /([^:]+)/.exec(this.tarId)[1]
      const aliasItem = this.alias.find(item => item.id === machineId)
      return aliasItem ? aliasItem.alias : ''
    },
  },
  methods: {
    ...mapMutations(['setFrameIdx', 'setTotalFrameCount']),
    ...mapMutations('history', ['setLabelList']),
    ...mapActions(['fetchCameraList', 'fetchVideoYaml']),
    ...mapActions('history', ['fetchHistoryList']),
    onDecoded(canvasData, totalFrameCount) {
      const frameIdx = this.$route.query.frame || 0
      this.setFrameIdx(Number(frameIdx))
      this.setTotalFrameCount(Number(totalFrameCount))
    },
    setFrameRangeStart() {
      const curFrameIdx = this.frameIdx
      const curFrameRange = this.frameRange
      if (curFrameIdx <= curFrameRange[1]) {
        this.frameRange = [curFrameIdx, curFrameRange[1]]
      } else {
        this.frameRange = [curFrameIdx, curFrameIdx]
      }
    },
    setFrameRangeEnd() {
      const curFrameIdx = this.frameIdx
      const curFrameRange = this.frameRange
      if (curFrameIdx >= curFrameRange[0]) {
        this.frameRange = [curFrameRange[0], curFrameIdx]
      } else {
        this.frameRange = [curFrameIdx, curFrameIdx]
      }
    },
    onMouseWheel(e) {
      this.isPlaying = false
      if (e.deltaY > 0) {
        this.frameIdx--
      } else {
        this.frameIdx++
      }
    },
    setLabel(idx) {
      if (this.historys[idx]) {
        const labelData = JSON.parse(this.historys[idx].labelData)
        const labelList = labelData.map(label => {
          return {
            type: `${label.type}_${label.typeDetail}`,
            frameRange: [label.startIndex, label.endIndex],
            area: label.position,
          }
        })
        this.setLabelList(labelList)
      } else {
        this.setLabelList([])
      }
    },
  },
  watch: {
    cameraId(val) {
      if (val >= 0) {
        this.fetchHistoryList()
      }
    },
    frameRange() {
      this.setLabelListFrameRange()
    },
    selectedHistoryIdx(idx) {
      this.setLabel(idx)
    },
    historys() {
      this.setLabel(0)
    },
  },
  components: {
    Version,
    Labeler,
    PlayControl,
    WebGLSnapshot,
    ClothAssessment,
  },
}
</script>

<style lang="scss">
.bitrate-select {
  width: 100px;
  .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  .el-input__icon {
    line-height: 20px;
  }
}
</style>

<style lang="scss" scoped>
.history {
  flex: 99;
  max-width: 1940px;
  overflow: auto;
  &-layer {
    margin: 5px;
  }
  &-labeler {
    box-shadow: 0px 2px 5px #ccc;
    margin: 10px;
    padding-bottom: 5px;
  }
  &-camera {
    width: 100%;
    max-width: 1920px;
    display: flex;
    align-items: center;
    padding: 0 10px 10px;
  }
  &-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-around;
  }
  &-list {
    padding: 5px;
    border: 1px solid #ccc;
    overflow: auto;
    height: 0;
    text-align: left;
    flex: 1;
    overflow: auto;
    border-radius: 4px;
    & > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
      padding: 0 5px;
    }
    & .active {
      background: #00f1;
    }
  }

  &-tag {
    width: 100%;
    height: 0px;
    & .el-tag {
      margin-right: 2px;
    }
  }
}
.box {
  padding: 10px;
  margin: 15px 10px 10px 10px;
  box-shadow: 0px 2px 5px #ccc;
  border-radius: 4px;
}
</style>
